var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        { attrs: { "label-position": "top" } },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("routes.班次编号") } },
                    [
                      _c("ScheduleNumberSelect", {
                        attrs: { list: _vm.scheduleNumberList, "is-all": "" },
                        model: {
                          value: _vm.queryForm.params.scheduleNumber,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.queryForm.params,
                              "scheduleNumber",
                              $$v
                            )
                          },
                          expression: "queryForm.params.scheduleNumber",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-col", { attrs: { span: 6 } }, [
                _c(
                  "div",
                  { staticStyle: { "margin-top": "30px" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          size: "small",
                          icon: "el-icon-search",
                        },
                        on: { click: _vm.asyncGetList },
                      },
                      [_vm._v(_vm._s(_vm.$t("operationCenter.Procurar")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", icon: "el-icon-refresh-left" },
                        on: { click: _vm.reset },
                      },
                      [_vm._v(_vm._s(_vm.$t("GlobalSetObj.reset")))]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        {
          staticClass: "box-card table-height",
          style: { height: _vm.tableHeightRow.height + "px" },
        },
        [
          _c(
            "el-button",
            {
              staticStyle: { "margin-bottom": "10px" },
              attrs: { type: "primary", size: "small", icon: "el-icon-plus" },
              on: { click: _vm.open },
            },
            [_vm._v(_vm._s(_vm.$t("routes.新增班次")))]
          ),
          _c(
            "el-table",
            {
              attrs: {
                border: "",
                data: _vm.tableData,
                "header-cell-style": { background: "#f2f2f2", color: "black" },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("GlobalSetObj.serial"),
                  type: "index",
                  width: "70",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("routes.班次编号"),
                  "min-width": "120",
                  prop: "scheduleNumber",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("GlobalSetObj.client"),
                  "min-width": "120",
                  prop: "customerNameList",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.ArrivalAtTransferCenter"),
                  "min-width": "120",
                  prop: "transferCenterName",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.lanshouT"),
                  "min-width": "120",
                  align: "center",
                  prop: "collectTime",
                  "class-name": "collectTimeList",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.collectTimeList,
                        function (item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticStyle: { padding: "5px 10px" },
                              style: {
                                "border-bottom":
                                  index < scope.row.collectTimeList.length - 1
                                    ? "1px solid #ebeef5"
                                    : "",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(item.collectTime[0]) +
                                  " ~ " +
                                  _vm._s(item.collectTime[1]) +
                                  " "
                              ),
                            ]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("GlobalSetObj.collectuploadTime"),
                  "min-width": "120",
                  prop: "collectTimeList",
                  align: "center",
                  "class-name": "collectTimeList",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.collectTimeList,
                        function (item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticStyle: { padding: "5px 10px" },
                              style: {
                                "border-bottom":
                                  index < scope.row.collectTimeList.length - 1
                                    ? "1px solid #ebeef5"
                                    : "",
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(item.collectLoadFinishTime) + " "
                              ),
                            ]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.ArrivalTimeAtTransferCenter"),
                  "min-width": "120",
                  prop: "hub1ArrivalTime",
                  align: "center",
                  "class-name": "collectTimeList",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.collectTimeList,
                        function (item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticStyle: { padding: "5px 10px" },
                              style: {
                                "border-bottom":
                                  index < scope.row.collectTimeList.length - 1
                                    ? "1px solid #ebeef5"
                                    : "",
                              },
                            },
                            [_vm._v(" " + _vm._s(item.hub1ArrivalTime) + " ")]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.operation"),
                  width: "120",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              content: _vm.$t("CenterForSorting.edit"),
                              effect: "dark",
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.edit(scope.row)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "el-icon-edit-outline hoverClass",
                                  staticStyle: {
                                    "font-size": "22px",
                                    color: "#00A551",
                                  },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              content: _vm.$t("GlobalSetObj.Delete"),
                              effect: "dark",
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "el-popconfirm",
                              {
                                attrs: {
                                  title: _vm.$t(
                                    "GlobalSetObj.AreYouSureDelete"
                                  ),
                                },
                                on: {
                                  confirm: function ($event) {
                                    return _vm.deleteClass(scope.row)
                                  },
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { margin: "0 10px" },
                                    attrs: {
                                      slot: "reference",
                                      size: "mini",
                                      type: "text",
                                    },
                                    slot: "reference",
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-delete hoverClass",
                                      staticStyle: {
                                        "font-size": "22px",
                                        color: "#f56c6c",
                                      },
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                staticStyle: { margin: "10px 0", float: "right" },
                attrs: {
                  "current-page": _vm.queryForm.pageNumber,
                  "page-size": _vm.queryForm.pageSize,
                  "page-sizes": [10, 20, 50, 100],
                  total: _vm.total,
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.addRow.title,
            visible: _vm.addRow.isBool,
            "close-on-press-escape": false,
            "close-on-click-modal": false,
            top: "5vh",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.addRow, "isBool", $event)
            },
          },
        },
        [
          _c("AddCmp", {
            key: _vm.addRow.isBool,
            attrs: {
              index: _vm.addRow.index,
              row: _vm.addRow,
              "transfer-list": _vm.transferList,
            },
            on: { close: _vm.onClose },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }